import React, { memo } from 'react';

function NotFound() {
  return (
    <div>
      <h1>Упс! 404</h1>
      <hr/>
      <p>Кажется такой страницы нет...</p>
    </div>
  );
}

export default memo(NotFound);



// WEBPACK FOOTER //
// ./src/pages/NotFound/index.jsx